import {getBlob} from "../../utils/idbBlobStorage";
// Types d'actions
export const UPDATE_PROJECT_FIELD = 'UPDATE_PROJECT_FIELD';
export const ADD_PROJECT_PHOTO = 'ADD_PROJECT_PHOTO';
export const REMOVE_PROJECT_PHOTO = 'REMOVE_PROJECT_PHOTO';
export const SET_PROJECT_VIDEO = 'SET_PROJECT_VIDEO';

export const SEND_PROJECT_REQUEST = 'SEND_PROJECT_REQUEST';
export const SEND_PROJECT_SUCCESS = 'SEND_PROJECT_SUCCESS';
export const SEND_PROJECT_FAILURE = 'SEND_PROJECT_FAILURE';

// Action creators simples
export const updateProjectField = (field, value) => ({
  type: UPDATE_PROJECT_FIELD,
  payload: { field, value },
});

export const addProjectPhoto = (photo) => ({
  type: ADD_PROJECT_PHOTO,
  payload: photo,
});

export const removeProjectPhoto = (index) => ({
  type: REMOVE_PROJECT_PHOTO,
  payload: index,
});

export const setProjectVideo = (video) => ({
  type: SET_PROJECT_VIDEO,
  payload: video,
});

// Thunk : envoyer un projet à l'API
export const sendProject = () => {
  return async (dispatch, getState) => {
    dispatch({ type: SEND_PROJECT_REQUEST });

    const { token } = getState().auth;
    const { projectToPost } = getState().project;
    const formData = new FormData();

    // Champs simples
    formData.append('titleProject', projectToPost.titleProject);
    formData.append('descriptionProject', projectToPost.descriptionProject);
    formData.append('idService', projectToPost.idService);
    formData.append('budgetProject', projectToPost.budgetProject);
    formData.append('statusProject', projectToPost.statusProject || 'posted');
    formData.append('isProfessionalProject', projectToPost.isProfessionalProject ? '1' : '0');

    // Vidéo
    if (projectToPost.videoPresentationProject) {
      const videoBlob = await getBlob(projectToPost.videoPresentationProject);
      if (videoBlob) {
        formData.append('videoPresentationProject', videoBlob, 'video.mp4');
      }
    }

    // Photos
    const photoPromises = projectToPost.photosProject.map((key, idx) =>
      getBlob(key).then(blob => {
        if (blob) {
          formData.append(`photosProject[${idx}]`, blob, `photo_${idx}.jpg`);
        }
      })
    );

    await Promise.all(photoPromises); // attend que toutes les photos soient ajoutées

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/projects`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          // Ne surtout pas ajouter "Content-Type", sinon FormData ne fonctionne pas correctement
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Échec de la soumission');
      }

      const data = await response.json();
      dispatch({ type: SEND_PROJECT_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: SEND_PROJECT_FAILURE });
      console.error('Erreur lors de l\'envoi du projet :', error);
    }
  };
};